// extracted by mini-css-extract-plugin
export var promotionLink = "_vt-0";